import React from "react";
import { getPathAndQuery } from "../../util/UrlFragmentSearch";

/**
 * @typedef {object} SiteMap
 * @property {string} id
 * @property {SiteMapNode[]} routes
 * @property {boolean} [hidenav]
 * @property {boolean} [drillIn]
 */

 /**
 * @typedef {object} SiteMapNode
 * @property {string} path
 * @property {string} title
 * @property {string} [icon]
 * @property {boolean} [excludeFromMenu]
 * @property {boolean} [isConfigPortal]
 * @property {SiteMapNode[]} [children]
 */

/** @type {SiteMap[]} */
export const billingAdminSiteMap = {
  drillIn: true,
  hideNav: true,
  routes: [
    {
      icon: "far fa-stethoscope",
      title: "ChatmeterAdmin",
      path: "/chatmeterAdmin",
      excludeFromMenu: true
    },
    {
      icon: "far fa-stethoscope",
      title: "Healthmeter",
      path: "/healthmeter/providerStatus/summary"
    },
    {
      icon: "far fa-chart-bar",
      title: "Listing Health Stats",
      path: "/healthmeter/listingStats/summary"
    },
    {
      icon: "far fa-dollar-sign",
      title: "Billing Accounts",
      path: "/chatmeterAdmin/billingAccounts"
    },
    {
      icon: "fab fa-yelp",
      title: "Yelp Subscriptions",
      path: "/yelpSubscription"
    },
    {
      icon: "far fa-clock",
      title: "LLM Recent Locations",
      path: "/listingManagement/listingManagementStats/recentLocations"
    },
    {
      icon: "fas fa-th-list",
      title: "Keywords",
      path: "/chatmeterAdmin/keywords"
    },
    {
      icon: "fas fa-industry-alt",
      title: "Verticals",
      path: "/chatmeterAdmin/verticals"
    },
    {
      icon: "far fa-arrow-left",
      title: "Advice Local Back-Sync",
      path: "/adviceLocalBackSync"
    },
    {
      icon: "fas fa-coffee",
      title: "Manage Tool",
      path: "/manageTool"
    },
    {
      icon: "fas fa-chart-area",
      title: "Listing Summary",
      path: "/listingSummary"
    },
    {
      icon: "far fa-sync-alt",
      title: "LLM Publishing",
      path: "/admin/listingManagement"
    }
  ]
}

export default function AdminMenu({}) {
  const { pathname } = getPathAndQuery();
  return (
    <div className="chatmeter-admin admin-menu">
      <ul>
        {billingAdminSiteMap.routes.map(({ icon, title, path, excludeFromMenu }) => {
          if(excludeFromMenu){
            return null;
          }
          
          return (
            <li key={path}>
              {
                <a
                  className={pathname.startsWith(path) ? "active" : ""}
                  href={"/#" + path}
                >
                  <span className={icon} /> {title}
                </a>
              }
            </li>
          );
        })}
      </ul>
    </div>
  );
}
